import kintFunctions from '~kint/firebase/functions.ts';

export default async function readMessages(chatId: string, participantId: string) {
  await kintFunctions.call('readChat', { chatId, participantId });
}
